(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("WTSDK", [], factory);
	else if(typeof exports === 'object')
		exports["WTSDK"] = factory();
	else
		root["WTSDK"] = factory();
})(self, function() {
return 